import { useNavigate } from 'react-router-dom';
import { SCENARIOS, useDashboard } from '../../context/DashboardContext';
import { useWorkspace } from '../../integrationQA/context/WorkspaceContext';

const SHOW_SIM = process.env.REACT_APP_SHOW_STATE_SIMULATOR !== 'false';

export default function Topbar({ onMenu, menuOpen }) {
  const { scenario, setScenario } = useDashboard();
  const { userName, userEmail, tenant, teamRole } = useWorkspace();
  const navigate = useNavigate();
  const displayName = userName || userEmail || 'Account';
  return (
    <header className="cb-topbar d-flex align-items-center gap-3">
      <button
        type="button"
        className="btn btn-light d-lg-none"
        onClick={onMenu}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
        aria-controls="cb-sidebar"
      >
        <i className="bi bi-list fs-5" aria-hidden="true" />
      </button>

      {SHOW_SIM && (
        <div className="ms-auto d-flex align-items-center gap-2">
          <label htmlFor="cb-sim" className="small text-muted mb-0 d-none d-md-block">Data state</label>
          <select id="cb-sim" className="form-select form-select-sm w-auto" value={scenario} onChange={(e) => setScenario(e.target.value)}>
            {SCENARIOS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </div>
      )}

      <button type="button" className={`btn btn-light position-relative ${SHOW_SIM ? '' : 'ms-auto'}`} aria-label="Notifications">
        <i className="bi bi-bell" aria-hidden="true" />
        <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger rounded-circle"><span className="visually-hidden">New notifications</span></span>
      </button>

      <div className="d-flex align-items-center gap-2">
        <span className="cb-avatar" aria-hidden="true">{displayName.charAt(0).toUpperCase()}</span>
        <span className="small fw-medium d-none d-sm-inline" title={tenant?.name ? `${tenant.name} · ${teamRole || ''}` : undefined}>{displayName}</span>
        <button type="button" className="btn btn-sm btn-outline-secondary ms-1" onClick={() => navigate('/logout')} aria-label="Sign out">
          <i className="bi bi-box-arrow-right" aria-hidden="true" /> <span className="d-none d-md-inline">Sign out</span>
        </button>
      </div>
    </header>
  );
}
